import React, { useRef, useState } from 'react';
import { useIntersection } from '../../hooks/useIntersectionObserver';

interface LazyImageProps {
  src?: string;
  className: string;
}

const LazyImage = ({ src, className }: LazyImageProps) => {
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef<HTMLDivElement | null>(null);
  useIntersection(imgRef, () => {
    setIsInView(true);
  });

  return (
    <div
      className={className}
      ref={imgRef}
      style={{
        backgroundImage: isInView ? src : undefined,
      }}
    />
  );
};

export default LazyImage;
